module.exports = __webpack_public_path__ + "img/project-foil.839fe2ee.png";